<div class="tw-flex tw-flex-col tw-mx-auto tw-px-4 lg:tw-px-0 tw-w-full lg:tw-max-w-[1296px]">
    @if (isLoading() && !personas().length) {
        <div class="tw-pt-4">
            <div class="tw-pb-6">
                <ngx-skeleton-loader count="1" [theme]="{ width: '220px', height: '32px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
            </div>
            <div class="tw-flex tw-flex-wrap tw-gap-5">
                <ngx-skeleton-loader class="tw-w-full lg:tw-w-[309px]" [theme]="{ height: '300px', 'margin-bottom': '8px' }" ></ngx-skeleton-loader>
                <ngx-skeleton-loader class="tw-w-full lg:tw-w-[309px]" [theme]="{ height: '300px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader class="tw-w-full lg:tw-w-[309px]" [theme]="{ height: '300px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader class="tw-w-full lg:tw-w-[309px]" [theme]="{ height: '300px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
            </div>
        </div>
    } @else if (!personas().length) {
        <div class="tw-mt-[118px] lg:tw-mt-[147px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 lg:tw-max-w-[636px] lg:tw-self-center">
            <img src="/assets/images/v2/noPersonas.svg" />
            <div>
                <h1 class="tw-text-lg lg:tw-text-xl tw-text-gray-900 tw-font-bold tw-text-center tw-mb-2 tw-font-inter">No Attendee Personas yet!</h1>
                <p class="tw-text-center tw-text-gray-500 tw-font-medium tw-text-sm lg:tw-text-base">Start by creating your first Attendee Personas to build custom registration forms, attendee journeys, and confirmations.</p>
            </div>
            <button class="tw-font-inter tw-bg-blue-600 tw-text-white tw-text-sm lg:tw-text-base tw-font-medium tw-rounded-lg tw-px-5 tw-py-2.5 lg:tw-py-[14px] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-10 lg:tw-h-[52px] lg:tw-w-[420px]" (click)="openCreatePersonaModal()"><i class="fas fa-plus tw-text-white tw-text-base"></i>Create first persona</button>
        </div>
    } @else {
        <div class="tw-pt-4 lg:tw-px-16 xl:tw-px-0">
            <div class="tw-pb-6 lg:tw-flex lg:tw-flex-row lg:tw-items-center lg:tw-justify-between">
                <div class="tw-flex tw-mb-0.5 lg:tw-mb-0 lg:tw-flex-col tw-justify-between tw-gap-0 lg:tw-gap-1">
                    <h1 class="tw-text-gray-700 tw-text-lg lg:tw-text-[28px] tw-font-bold tw-font-inter tw-leading-7 lg:tw-leading-[125%]">Attendee Personas</h1>
                    <p class="tw-hidden lg:tw-block tw-tracking-[5%] tw-text-gray-500 tw-text-sm lg:tw-text-base tw-font-normal tw-font-inter tw-leading-7">Create tailored registration journeys for each Attendee Persona.</p>
                    <button type="button" class="lg:tw-hidden tw-font-inter tw-text-blue-600 lg:tw-text-white lg:tw-bg-blue-600 tw-text-sm lg:tw-text-base tw-font-medium tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-gap-1 lg:tw-gap-2 lg:tw-px-5 lg:tw-py-2.5" (click)="openCreatePersonaModal()"><svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_42485_98373)">
                        <path d="M11.3333 5.33333H6.66667V0.666667C6.66667 0.489856 6.59643 0.320286 6.4714 0.195262C6.34638 0.0702379 6.17681 0 6 0C5.82319 0 5.65362 0.0702379 5.5286 0.195262C5.40357 0.320286 5.33333 0.489856 5.33333 0.666667V5.33333H0.666667C0.489856 5.33333 0.320286 5.40357 0.195262 5.5286C0.0702379 5.65362 0 5.82319 0 6C0 6.17681 0.0702379 6.34638 0.195262 6.4714C0.320286 6.59643 0.489856 6.66667 0.666667 6.66667H5.33333V11.3333C5.33333 11.5101 5.40357 11.6797 5.5286 11.8047C5.65362 11.9298 5.82319 12 6 12C6.17681 12 6.34638 11.9298 6.4714 11.8047C6.59643 11.6797 6.66667 11.5101 6.66667 11.3333V6.66667H11.3333C11.5101 6.66667 11.6797 6.59643 11.8047 6.4714C11.9298 6.34638 12 6.17681 12 6C12 5.82319 11.9298 5.65362 11.8047 5.5286C11.6797 5.40357 11.5101 5.33333 11.3333 5.33333Z" fill="currentColor"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_42485_98373">
                        <rect width="12" height="12" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>
                        Create persona
                    </button>
                </div>
                <button type="button" class="tw-hidden tw-h-[42px] tw-font-inter tw-text-blue-600 lg:tw-text-white lg:tw-bg-blue-600 tw-text-sm lg:tw-text-base tw-font-medium tw-rounded-lg lg:tw-flex tw-items-center tw-justify-center tw-gap-1 lg:tw-gap-2 lg:tw-px-5 lg:tw-py-2.5" (click)="openCreatePersonaModal()"><svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_42485_98373)">
                    <path d="M11.3333 5.33333H6.66667V0.666667C6.66667 0.489856 6.59643 0.320286 6.4714 0.195262C6.34638 0.0702379 6.17681 0 6 0C5.82319 0 5.65362 0.0702379 5.5286 0.195262C5.40357 0.320286 5.33333 0.489856 5.33333 0.666667V5.33333H0.666667C0.489856 5.33333 0.320286 5.40357 0.195262 5.5286C0.0702379 5.65362 0 5.82319 0 6C0 6.17681 0.0702379 6.34638 0.195262 6.4714C0.320286 6.59643 0.489856 6.66667 0.666667 6.66667H5.33333V11.3333C5.33333 11.5101 5.40357 11.6797 5.5286 11.8047C5.65362 11.9298 5.82319 12 6 12C6.17681 12 6.34638 11.9298 6.4714 11.8047C6.59643 11.6797 6.66667 11.5101 6.66667 11.3333V6.66667H11.3333C11.5101 6.66667 11.6797 6.59643 11.8047 6.4714C11.9298 6.34638 12 6.17681 12 6C12 5.82319 11.9298 5.65362 11.8047 5.5286C11.6797 5.40357 11.5101 5.33333 11.3333 5.33333Z" fill="currentColor"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_42485_98373">
                    <rect width="12" height="12" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>
                    Create persona
                </button>
                <p class="lg:tw-hidden tw-leading-7 tw-text-gray-500 tw-text-sm lg:tw-text-base tw-font-normal tw-font-inter">Create tailored registration journeys for each Attendee Persona.</p>
            </div>
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-5">
                @for (persona of personas(); track persona.id) {
                    <app-persona-card [persona]="persona" class="tw-w-full" (landingPageClick)="openPersonaLandingPage($event)"  (personaNameCommit)="onPersonaNameCommit($event)"
                    (clonePersona)="onClonePersona($event)" (archivePersona)="onArchivePersona($event)" (managePersona)="openLegacyPersonaEditor($event)"></app-persona-card>
                 }
            </div>
            <div #loadMoreTrigger class="tw-h-8 tw-w-full"></div>
            @if (isLoading()) {
                <progress-circle [isInfinite]="true" class="tw-flex tw-items-center tw-justify-center" colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
            }
        </div>
    }
</div>

@if (isModalOpened(createPersonaModalId)) {
  <create-persona-modal
    [id]="createPersonaModalId"
    [isSubmitting]="isCreatingPersona()"
    [apiErrorBody]="createPersonaApiError()"
    (onCreate)="onCreatePersonaSubmitted($event)"
    (onCancel)="cancelCreatePersonaModal()"
  ></create-persona-modal>
}

@if (isModalOpened(clonePersonaModalId) && cloneSourcePersona(); as sourcePersona) {
  <clone-persona-modal
    [id]="clonePersonaModalId"
    [workspaceId]="organizationId"
    [eventId]="eventId"
    [sourcePersona]="sourcePersona"
    [eventSlug]="eventSlug"
    (cloned)="onPersonaCloned($event)"
    (onCancel)="closeClonePersonaModal()"
  ></clone-persona-modal>
}

@if (isModalOpened(confirmArchivePersonaModalId)) {
  <modal
    [id]="confirmArchivePersonaModalId"
    [showFooterDivider]="false"
    [showHeaderDivider]="false"
    [widthClass]="'tw-w-auto lg:tw-w-[416px]'"
    [heightClass]="'tw-h-auto'"
    [closeButtonEnabled]="true"
    [enableBackdropClose]="true"
    (onCloseModal)="cancelArchivePersona()"
  >
    <div class="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-py-2" slot="body">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_delete_persona_warning)">
              <path
                d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 15C9.80222 15 9.60888 14.9413 9.44443 14.8315C9.27998 14.7216 9.15181 14.5654 9.07612 14.3827C9.00044 14.2 8.98063 13.9989 9.01922 13.8049C9.0578 13.6109 9.15304 13.4327 9.2929 13.2929C9.43275 13.153 9.61093 13.0578 9.80491 13.0192C9.99889 12.9806 10.2 13.0004 10.3827 13.0761C10.5654 13.1518 10.7216 13.28 10.8315 13.4444C10.9414 13.6089 11 13.8022 11 14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12C9.73479 12 9.48043 11.8946 9.2929 11.7071C9.10536 11.5196 9 11.2652 9 11V6C9 5.73478 9.10536 5.48043 9.2929 5.29289C9.48043 5.10536 9.73479 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V11Z"
                fill="#9CA3AF"
              />
            </g>
            <defs>
              <clipPath id="clip0_delete_persona_warning">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
      <p class="tw-font-inter tw-text-gray-500 tw-px-4 tw-text-center tw-text-base tw-leading-6 tw-font-normal">
        Are you sure you want to archive <span class="tw-font-bold">{{ personaNameToArchive() }}</span> persona?
      </p>
      <p class="w-font-inter tw-text-gray-500 tw-px-4 tw-text-center tw-text-base tw-leading-6 tw-font-normal">You can access archived items anytime from the event’s menu (⋯).</p>
    </div>
    <div class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-pt-4 tw-pb-6" slot="footer">
      <button
        type="button"
        class="tw-flex tw-items-center tw-justify-center tw-text-white tw-bg-red-600 hover:tw-bg-red-700 focus:tw-ring-4 focus:tw-ring-red-300 tw-font-medium tw-rounded-md tw-text-sm focus:tw-outline-none tw-px-3 tw-py-2 tw-font-inter"
        (mousedown)="$event.preventDefault()"
        (click)="confirmArchivePersona()"
      >
        Yes, I'm sure
      </button>
      <button
        type="button"
        class="tw-flex tw-items-center tw-justify-center tw-border tw-text-gray-800 tw-bg-white hover:tw-bg-gray-100 tw-font-medium tw-rounded-md tw-text-sm focus:tw:outline-none tw-border-gray-200 tw-px-3 tw-py-2 tw-font-inter"
        (mousedown)="$event.preventDefault()"
        (click)="cancelArchivePersona()"
      >
        No, cancel
      </button>
    </div>
  </modal>
}